import React from 'react'
import { ArrowRight } from 'lucide-react'
import { toGO } from '../navBar'

const Stats = () => {
  const stats = [
    {
      value: '4/5',
      description: '17,600 reviews on Trustpilot.',
      link: 'Our values',
      href: '#'
    },
    {
      value: '1.5M+',
      description: 'Active users on the Bitvavo platform.',
      link: 'Sign up',
      href: '#'
    },
    {
      value: '10B',
      description: 'Monthly trading volume.',
      link: 'View exchange',
      href: '#'
    },
    {
      value: '350+',
      description: 'Digital assets you can buy, store, and trade.',
      link: 'Assets',
      href: '#'
    }
  ]

  return (
    <div className='max-md:px-4'>
      <div className='grid grid-cols-1 md:grid-cols-4 divide-y md:divide-y-0 md:divide-x divide-gray-100'>
        {stats.map((stat, index) => (
          <div key={index} className='py-8 md:py-0 px-0 md:px-8 text-center' onClick={toGO}>
            <div className='text-3xl md:text-4xl font-bold text-blue-600 mb-3 md:mb-4'>{stat.value}</div>
            <div className='text-base md:text-base text-gray-600 mb-3 md:mb-4'>{stat.description}</div>
            <a
              onClick={toGO}
              // href={stat.href}
              className='inline-flex items-center text-blue-600 hover:text-blue-700 font-medium'>
              {stat.link}
              <ArrowRight className='w-4 h-4 ml-1' />
            </a>
          </div>
        ))}
      </div>
    </div>
  )
}

export default Stats
